<script setup>
import { useCommonComposable } from '@/composables/commonComposable';
const { useTypingAnimation } = useCommonComposable();

const props = defineProps({
    text: {
        type: [String, Array, Function],
        required: true
    },

    typingSpeed: {
        type: Number,
        default: 40
    },

    restartDelay: {
        type: [Number, String],
        default: 5000
    },

    pauseBeforeRestart: {
        type: Number,
        default: 350
    }
})

const { typedText } = useTypingAnimation(
    () => props.text,
    {
        typingSpeed: props.typingSpeed,
        restartDelay: props.restartDelay,
        pauseBeforeRestart: props.pauseBeforeRestart
    }
)
</script>

<template>
    <span>{{ typedText }}</span>
</template>